// Importing Link component from react-router-dom to enable client-side navigation
import { Link } from 'react-router-dom';

// Footer component renders the bottom section of the website
function Footer() {
  return (
  <footer className="bg-gray-900 text-white py-12">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* About Section */}
        <div>
          <h3 className="text-xl font-bold mb-4 tracking-tight">LearnSphere</h3>
          <p className="text-gray-400 text-sm leading-relaxed">
            Empowering education through innovative technology.
          </p>
        </div>

        {/* Quick Links Section */}
        <div>
          <h3 className="text-xl font-bold mb-4 tracking-tight">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link
                to="/courses"
                className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
              >
                Courses
              </Link>
            </li>
            <li>
              <Link
                to="/profile"
                className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
              >
                Profile
              </Link>
            </li>
            <li>
              <Link
                to="/chat"
                className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
              >
                Chat
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="text-xl font-bold mb-4 tracking-tight">Contact Us</h3>
          <p className="text-gray-400 text-sm mb-1">
            Email:{' '}
            <a
              href="mailto:bightiyahen@gmail.com"
              className="hover:text-white underline transition-colors duration-200"
            >
              bightiyahen@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-sm">Phone: (663) 187-435</p>
        </div>
      </div>

      {/* Footer bottom copyright */}
      <div className="mt-10 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
        © 2025 LearnSphere. All rights reserved.
      </div>
    </div>
  </footer>
);

}
export default Footer;
